import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllProductTypes = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'productTypes', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getAllProductTypesObject = async () => {
    const allProductTypes = await getAllProductTypes();
    const allProductTypesObject = allProductTypes.map((productType , index) => {
        return {
            id : productType.id,
            value : productType.id,
            label : productType.type.persianLabel,
            parentId : null,
        }
    })
    return allProductTypesObject;
}